import S from './RecruitmentCardEnd.module.scss';
import styled from 'styled-components';
import thumbDefaultImg from '../../ivy/Recruitment/assets/default_recruit_img.svg';
import React, { useEffect, useState } from 'react';
import RecruitFlag from '../RecruitFlag';
import Bookmark from '../Bookmark';
import { RecruitmentContentType, RecruitmentDetailType } from '../../../types/RecruitmentTypes';
import { AuthUtils } from '../../../utils/AuthUtils';
import { fetchRecruitments } from '../../../repository/RecruitmentRepository';
import RecruitmentCard from '../RecruitmentCard';
import iconRightArrow from '../../common/assets/icon_right_arrow.svg';
import dayjs from 'dayjs';

interface RecruitmentEndDetailProps {
  id?: string;
  content: RecruitmentDetailType;
}

const RecruitmentEndDetail = (props: RecruitmentEndDetailProps) => {
  const { id, content } = props;
  const RECRUITMENT_END_LIST_SIZE = 6;
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const [recruitments, setRecruitments] = useState<RecruitmentContentType[]>([]);
  const token = AuthUtils.getCookie('token');

  const getRecruitmentList = (id: number) => {
    fetchRecruitments('', [], true, id?.toString(), RECRUITMENT_END_LIST_SIZE, token)
      .then((res) => {
        if (res && res.content.length > 0) {
          setRecruitments(res.content);
        }
      })
      .catch((e) => console.error(e));
  };

  const formatContentDate = (endAt: string) => {
    const date = new Date(endAt);
    return dayjs(date).format('YYYY-MM-DD');
  };

  const handleOpenNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  useEffect(() => {
    if (content.id !== undefined) {
      setIsBookmarked(content.isBookmarked);
      getRecruitmentList(content.id);
    }
  }, [content]);

  if (content === undefined) {
    return null;
  }

  return (
    <>
      <section className={S.recruit_end_section}>
        {/* 채용 타이틀 & 위치 */}
        <div className={S.recruit_top_info}>
          <div className={S.recruit_title_area}>
            <h2 className="h2">{content.title}</h2>
            <h6 className="b1">{`${content.company?.name} / ${content.region?.name}`}</h6>
          </div>
          <div className={S.bookmark_icon_area}>
            <Bookmark
              id={content.id}
              isBookmarked={isBookmarked}
              setIsBookmarked={setIsBookmarked}
            />
          </div>
        </div>
        {/* 채용 관련 태그 */}
        <div className={S.recruit_flag_wrap}>
          {content.filters?.map((filter, index) => (
            <RecruitFlag title={filter.displayName || ''} key={`recruitment_filter_${index}`} />
          ))}
        </div>
        {/* 채용 정보 디테일 */}
        <div className={S.recruit_detail_area}>
          {/* 이미지 없는 경우 디폴트 이미지 */}
          <RecruitThumbImg backgroundImage={thumbDefaultImg}></RecruitThumbImg>
          {/* <RecruitThumbImg backgroundImage={thumbExampleImg}></RecruitThumbImg> */}
          <div className={S.recruit_detail_text}>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>직무 내용</h4>
              <p
                className={`b2 ${S.field_detail}`}
                style={content.description === '' ? { display: 'none' } : {}}
              >
                {content.description}
              </p>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>근무 형태</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.workType === '' ? { display: 'none' } : {}}
                >
                  {content.workType}
                </li>
              </ul>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>자격 요건</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.education === '' ? { display: 'none' } : {}}
                >
                  학력 : {content.education}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.career === '' ? { display: 'none' } : {}}
                >
                  경력 : {content.career}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.pfCond === '' ? { display: 'none' } : {}}
                >
                  필수 조건 : {content.pfCond}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.certificate === '' ? { display: 'none' } : {}}
                >
                  자격증 : {content.certificate}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.major === '' ? { display: 'none' } : {}}
                >
                  전공 : {content.major}
                </li>
              </ul>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>우대 사항</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.pfCond === '' ? { display: 'none' } : {}}
                >
                  {content.pfCond}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.etcPfCond === '' ? { display: 'none' } : {}}
                >
                  {content.etcPfCond}
                </li>
              </ul>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>복리 후생</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.insurance === '' ? { display: 'none' } : {}}
                >
                  {content.insurance}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.salaryType === '' ? { display: 'none' } : {}}
                >
                  급여 방식 : {content.salaryType}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.salaryDetail === '' ? { display: 'none' } : {}}
                >
                  급여 상세 : {content.salaryDetail}
                </li>
              </ul>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>기업 정보</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.company?.name === '' ? { display: 'none' } : {}}
                >
                  이름 : {content.company?.name}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.company?.industry === '' ? { display: 'none' } : {}}
                >
                  직종 : {content.company?.industry}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.company?.scale === '' ? { display: 'none' } : {}}
                >
                  규모 : {content.company?.scale}
                </li>
                <li
                  className={S.field_detail_li}
                  style={
                    content.basicAddress === '' || content.detailAddress === ''
                      ? { display: 'none' }
                      : {}
                  }
                >
                  근무지 위치 : {content.basicAddress}
                  {content.detailAddress !== '' ? `, ${content.detailAddress}` : ''}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.phoneNumber === '' ? { display: 'none' } : {}}
                >
                  전화번호 : {content.phoneNumber}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.faxNumber === '' ? { display: 'none' } : {}}
                >
                  팩스 : {content.faxNumber}
                </li>
              </ul>
            </div>
            <div className={S.recruit_text_line}>
              <h4 className={`h4 ${S.recruit_field}`}>접수 기간 및 방법</h4>
              <ul className={S.field_detail_ul}>
                <li
                  className={S.field_detail_li}
                  style={content.endAt === '' ? { display: 'none' } : {}}
                >
                  기간 : ~{formatContentDate(content.endAt)}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.submitDocumentation === '' ? { display: 'none' } : {}}
                >
                  제출 서류 : {content.submitDocumentation}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.screeningMethod === '' ? { display: 'none' } : {}}
                >
                  채용 방식 : {content.screeningMethod}
                </li>
                <li
                  className={S.field_detail_li}
                  style={content.receiptMethod === '' ? { display: 'none' } : {}}
                >
                  제출 방식 : {content.receiptMethod}
                </li>
              </ul>
            </div>
          </div>
          {content.jobLink && (
            <div className={S.link_btn_wrap}>
              <button
                type="button"
                onClick={() => {
                  handleOpenNewTab(`${content.jobLink}`);
                }}
              >
                채용정보 제공 사이트로 이동하기
                <img src={iconRightArrow} alt="채용정보 제공 사이트로 이동" />
              </button>
            </div>
          )}
        </div>
        <section className={S.recruit_post_section}>
          <h2 className="h2">채용공고</h2>
          <div className={S.recruit_post_wrap}>
            {recruitments.map((recruitment, index) => {
              return <RecruitmentCard key={`end_card_${index}`} content={recruitment} />;
            })}
          </div>
        </section>
      </section>
    </>
  );
};

export default RecruitmentEndDetail;

const RecruitThumbImg = styled.div<{ backgroundImage: string }>`
  width: 100%;
  height: 51.8rem;
  border-radius: 1rem;
  border: 1px solid #eaedf1;
  background-image: url(${(props) => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
